import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { ShoppingCartIcon, CheckIcon } from 'lucide-react';
export function OfferSection() {
  const checkoutLink = 'http://checkout.sabores365.online/cart/59169279508561:1';
  const benefits = ['Pago único.', 'Acceso inmediato.', 'Descarga instantánea.'];
  return <section id="oferta" className="py-24 bg-[#FFF8F0] text-[#3D2B1F] px-4 relative overflow-hidden" data-id="element-81">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#C67B30]/5 rounded-full blur-[150px] pointer-events-none" data-id="element-82"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] p-8 md:p-16 border-2 border-[#C67B30]/30 shadow-[0_0_50px_rgba(198,123,48,0.1)] text-center relative" data-id="element-84">
          {/* Badge */}
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-gradient-to-r from-red-600 to-red-500 text-white font-black px-8 py-3 rounded-full text-xl shadow-xl uppercase tracking-wider border-2 border-white" data-id="element-85">
            Oferta Especial
          </div>

          <h2 className="text-3xl md:text-5xl font-black mb-6 mt-4 text-[#3D2B1F]" data-id="element-86">
            Obtené acceso completo a todo el material por solo:
          </h2>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-87">
            <span className="text-3xl text-[#B09A8D] line-through font-bold mb-2" data-id="element-88">
              $39.990 ARS
            </span>
            <div className="flex items-start gap-2" data-id="element-89">
              <span className="text-4xl font-bold text-[#C67B30] mt-2" data-id="element-90">$</span>
              <span className="text-7xl md:text-8xl font-black text-[#C67B30] tracking-tighter" data-id="element-91">
                19.990
              </span>
              <span className="text-2xl font-bold text-[#C67B30] mt-auto mb-2" data-id="element-92">
                ARS
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-93">
            {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-2 bg-[#FFF8F0] px-4 py-2 rounded-full border border-[#3D2B1F]/10" data-id="element-94">
                <CheckIcon className="w-5 h-5 text-green-500" data-id="element-95" />
                <span className="font-bold text-[#4A3728]" data-id="element-96">{benefit}</span>
              </div>)}
          </div>

          <div className="mb-10" data-id="element-97">
            <p className="text-[#9C8578] font-bold uppercase tracking-widest mb-4 text-sm" data-id="element-98">
              La oferta expira en:
            </p>
            <div className="inline-block bg-[#3D2B1F]/5 px-6 py-3 rounded-xl border border-[#3D2B1F]/10" data-id="element-99">
              <CountdownTimer size="md" data-id="element-100" />
            </div>
          </div>

          <a href={checkoutLink} className="block w-full bg-gradient-to-r from-[#C67B30] to-[#D4943A] text-white font-black text-2xl md:text-3xl py-6 px-8 rounded-2xl shadow-[0_0_30px_rgba(198,123,48,0.4)] hover:shadow-[0_0_50px_rgba(198,123,48,0.6)] transform hover:scale-[1.02] transition-all duration-300 uppercase tracking-wide mb-8 flex items-center justify-center gap-4 group" data-id="element-101">
            <ShoppingCartIcon className="w-8 h-8 group-hover:scale-110 transition-transform" data-id="element-102" />
            ¡Sí, quiero acceder ahora!
          </a>

          <div className="space-y-4 text-[#9C8578] font-medium text-lg" data-id="element-103">
            <p data-id="element-104">
              En pocos minutos vas a poder descargar el libro y empezar a
              aplicar estas recetas en tu cocina.
            </p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-[#B09A8D]" data-id="element-105">
              <span data-id="element-106">✓ Sin esperar envíos</span>
              <span data-id="element-107">✓ Sin suscripciones</span>
              <span data-id="element-108">✓ Sin pagos recurrentes</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}